import { render, staticRenderFns } from "./Smilies.vue?vue&type=template&id=2851c20e&"
import script from "./Smilies.vue?vue&type=script&lang=js&"
export * from "./Smilies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports